var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.729,
    height: 18.199,
    viewBox: "0 0 15.729 18.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16320",
    d: "M16.777 5.39h-5.59a.962.962 0 0 1-.962-.962V2.962A.962.962 0 0 1 11.187 2h5.59a.962.962 0 0 1 .962.962v1.466a.962.962 0 0 1-.962.962z",
    transform: "translate(-6.114 -2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16321",
    d: "M17.315 4.61H16.5v.731a1.939 1.939 0 0 1-1.937 1.937h-5.59a1.939 1.939 0 0 1-1.937-1.937V4.61h-.809A2.324 2.324 0 0 0 3.9 6.937v11.849a2.324 2.324 0 0 0 2.327 2.327H17.3a2.324 2.324 0 0 0 2.327-2.327V6.937a2.309 2.309 0 0 0-2.312-2.327zm-6.559 9.641h-2.82a.585.585 0 0 1 0-1.17h2.82a.585.585 0 1 1 0 1.17zm3.453-3.32H7.936a.585.585 0 1 1 0-1.17h6.271a.585.585 0 0 1 0 1.17z",
    transform: "translate(-3.9 -2.914)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogue);
export default __webpack_public_path__ + "static/media/catalogue.b12a7d1b46a174093de89d61b725cb85.svg";
export { ForwardRef as ReactComponent };